import { CallApi, handleJSONResponse } from './common';
import { Subdomain } from '@services/subdomains/types/subdomain';
import { NewSubdomain } from '@services/subdomains/types/new-subdomain';

const callAPI = CallApi('subdomains');

export const get = async (ownerId: string): Promise<Subdomain> => {
  const response = await callAPI(`/owner/${ ownerId }`, 'GET');

  return handleJSONResponse(response);
}

export const query = async (name: string): Promise<Subdomain> => {
  const response = await callAPI(`/?name=${name}`, 'GET');

  return handleJSONResponse(response);
}

export const update = async (newSubdomain: NewSubdomain): Promise<Subdomain> => {
  const response = await callAPI('/', 'POST', newSubdomain);

  return handleJSONResponse(response);
}